<template>
    <div class="netBankingContainer">
        <div class="depositAmount mb-5">
            <div>
                Depositing Amount
            </div>
            <div>
                &#x20B9;{{ amount | localeAmount }}
            </div>
        </div>
        <PaymentDetailCard v-if="accountInfo" :paymentDetails="getPaymentDetails" :selectedPortfolio="portfolio"/>
    </div>
</template>

<script>
import PaymentDetailCard from '../common/paymentCard.vue'
import LenderService from '@/services/lenderService'

export default {
    name: 'NetBanking',
    props: ['portfolio', 'paymentDetails'],
    components: {
        PaymentDetailCard
    },
    data () {
        return {
            accountInfo: null,
            amount: 0
        }
    },
    mounted () {
        this.$store.commit('isLoading')
        this.amount = this.portfolio.investmentAmount / 100
        this.$store.commit('===========')
        LenderService.getVirtualAccountInfo().then((res) => {
            if (res.status === 200) {
                this.accountInfo = res.data
            }
            this.$store.commit('isNotLoading')
        })
    },
    computed: {
        getPaymentDetails () {
            return [
                {
                    label: 'Beneficiary',
                    value: this.$store.state.userName
                },
                {
                    label: 'Bank',
                    value: 'Yes Bank'
                },
                {
                    label: 'Account Number',
                    value: this.accountInfo.virtualAccountNumber
                },
                {
                    label: 'IFSC Code',
                    value: this.accountInfo.ifsc
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";

.v-application p {
    margin-bottom: 0px;
}

.depositAmount {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 500;
}

</style>
